import type { FileCategory } from './file-category.enum'
import type { HubloPoolDocumentType } from './hublo-pool-document-type.enum'

type FileCategoryAndHubloPoolDocTypeUnionType =
  | FileCategory
  | HubloPoolDocumentType

export const FileCategoryAndHubloPoolDocTypeUnion: Record<
  FileCategoryAndHubloPoolDocTypeUnionType,
  string
> = {
  CV: 'CV',
  DIPLOMA: 'DIPLOMA',
  CERTIFICATE_OF_COMPLETION: 'CERTIFICATE_OF_COMPLETION',
  DRIVING_LICENSE: 'DRIVING_LICENSE',
  IDENTITY_DOCUMENT: 'IDENTITY_DOCUMENT',
  IDENTITY_DOCUMENT_VERSO: 'IDENTITY_DOCUMENT_VERSO',
  RIB: 'RIB',
  VACCINATION_CERTIFICATE: 'VACCINATION_CERTIFICATE', // @deprecated type
  CRIMINAL_RECORD: 'CRIMINAL_RECORD',
  RESIDENCE_PROOF: 'RESIDENCE_PROOF',
  SS_CERTIFICATE: 'SS_CERTIFICATE',

  // new types included in FileTypes
  IDENTITY_DOCUMENT_RECTO: 'IDENTITY_DOCUMENT_RECTO',

  // Let HubloPoolDocumentType be the superset of FileCategory since else, we would need to change it everywhere having some impact and it's not the aim of the task
  // Still, we want not to have compatibility issues with possible types of documents sent.
  COVER_LETTER: 'COVER_LETTER',
  HEALTH_CARD: 'HEALTH_CARD',
  ONI_CERTIFICATE: 'ONI_CERTIFICATE',
  OTHER_DOCUMENT: 'OTHER_DOCUMENT',
  VACCINATION_RECORD_DTP: 'VACCINATION_RECORD_DTP',
  VACCINATION_RECORD_HEPATITIS_B: 'VACCINATION_RECORD_HEPATITIS_B',
  VACCINATION_RECORD_REPEVAX: 'VACCINATION_RECORD_REPEVAX',
  WORK_CERTIFICATE: 'WORK_CERTIFICATE',
  ADELI_CERTIFICATE: 'ADELI_CERTIFICATE',
  INSTITUTION_LOGO: 'INSTITUTION_LOGO',
  INSTITUTION_COVER_PICTURE: 'INSTITUTION_COVER_PICTURE',
} as const
export type FileCategoryAndHubloPoolDocTypeUnion =
  (typeof FileCategoryAndHubloPoolDocTypeUnion)[keyof typeof FileCategoryAndHubloPoolDocTypeUnion]
